import React from "react";
import { BRAND } from "../lib/brand";
import { BadgeCheck, HandHeart, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[color:var(--dbe-cream)] py-16 sm:py-24 md:py-32 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-[500px] h-[500px] rounded-full bg-[color:var(--dbe-red)]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center relative">
        <div>
          <p className="text-[color:var(--dbe-red)] text-xs tracking-[0.35em] uppercase font-bold">Our Story</p>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-bebas">
            Three generations.<br />
            <span className="text-[color:var(--dbe-red)]">One standard.</span>
          </h2>
          <p className="mt-5 sm:mt-6 text-base sm:text-lg text-neutral-700 leading-relaxed max-w-xl">
            When Bob Edwards started Dead Bug Edwards in {BRAND.since}, he did something simple -
            he gave every customer service worth talking about. More than 65 years later, that same
            promise runs every truck we send out across South Florida.
          </p>
          <p className="mt-4 text-base sm:text-lg text-neutral-700 leading-relaxed max-w-xl">
            We are never too busy to say <em>thank you for your business</em>. That's why families
            call us for their parents' homes, their kids' homes, and now their own.
          </p>

          <div className="mt-8 md:mt-10 grid grid-cols-3 gap-3 sm:gap-4">
            {[
              { icon: <BadgeCheck className="w-5 h-5 sm:w-6 sm:h-6" />, t: "65+", s: "Years in South FL" },
              { icon: <HandHeart className="w-5 h-5 sm:w-6 sm:h-6" />, t: "3", s: "Generations trusted" },
              { icon: <ShieldCheck className="w-5 h-5 sm:w-6 sm:h-6" />, t: "100%", s: "Satisfaction focus" },
            ].map((b) => (
              <div key={b.s} className="bg-white border border-black/5 rounded-2xl p-4 sm:p-5 shadow-sm">
                <div className="text-[color:var(--dbe-red)]">{b.icon}</div>
                <div className="mt-2 sm:mt-3 font-bebas text-3xl sm:text-4xl leading-none">{b.t}</div>
                <div className="text-[11px] sm:text-sm text-neutral-600 mt-1">{b.s}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative mt-8 lg:mt-0">
          <div className="relative rounded-[24px] sm:rounded-[32px] overflow-hidden shadow-[0_40px_80px_-30px_rgba(0,0,0,0.3)]">
            <img
              src="https://images.pexels.com/photos/4148897/pexels-photo-4148897.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Dead Bug Edwards pest control technician at a Florida home"
              loading="lazy"
              decoding="async"
              className="w-full h-[380px] sm:h-[460px] lg:h-[540px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-5 sm:bottom-6 left-5 sm:left-6 right-5 sm:right-6 text-white">
              <div className="text-xs uppercase tracking-[0.3em] opacity-80">Plantation, FL</div>
              <div className="mt-1 font-bebas text-2xl sm:text-3xl">Proudly local. Proudly family.</div>
            </div>
          </div>

          <img
            src={BRAND.badge65}
            alt="Over 65 Years of Service badge"
            className="absolute -top-6 -left-4 sm:-top-8 sm:-left-6 w-20 sm:w-28 md:w-36 rotate-[-10deg] drop-shadow-xl"
          />
        </div>
      </div>
    </section>
  );
}
